import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import { gqlClient } from '@/api/graphql-client';
import meKeys from '@/api/queries/me/keyFactory';
import { graphql } from '@/gql';
import {
  ArchiveDocumentTemplateMutation,
  ArchiveDocumentTemplateMutationVariables,
} from '@/gql/graphql';

const ArchiveDocumentTemplate = graphql(`
  mutation ArchiveDocumentTemplate($input: ArchiveDocumentTemplateInput!) {
    archiveDocumentTemplate(input: $input)
  }
`);

const useArchiveDocumentTemplate = (
  options?: UseMutationOptions<
    ArchiveDocumentTemplateMutation,
    unknown,
    ArchiveDocumentTemplateMutationVariables['input']
  >
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input) => {
      return gqlClient.request(ArchiveDocumentTemplate, {
        input,
      });
    },
    onSettled: (_a, _b, variables) => {
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountDocumentTemplates(),
      });
      void queryClient.invalidateQueries({
        queryKey: meKeys.accountDocumentTemplate(variables.id),
      });
    },
    ...options,
  });
};

export default useArchiveDocumentTemplate;
